module.exports = __webpack_public_path__ + "static/img/Hyderabad.e41a520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city/Hyderabad.png
// module id = Aob7
// module chunks = 12